import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { Observable } from "rxjs";
import { BerthProfile, DataSourceResponse } from "../../models";
import { HttpParamsEncoder } from "../../tools";

@Injectable({ providedIn: 'root' })
export class BerthProfileService extends ApiService {
  endPoint = '/api/BunkProfiles';
  create(model: BerthProfile) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: BerthProfile) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  get(id: string): Observable<BerthProfile> {
    return this.http.get<BerthProfile>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  getList(queryParams: any): Observable<DataSourceResponse<BerthProfile>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}